import { fixMissingBaysData } from "@tedivo/tedivo-ovd-validators";
export default function readOVDJsonFile(f) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
        reader.onload = (ev) => {
            try {
                const target = ev.target;
                const json = JSON.parse(target.result);
                if (isOvdSchema(json)) {
                    resolve(fixMissingBaysData(json));
                }
                else {
                    reject("errors:notValidOvdFile");
                }
            }
            catch (err) {
                reject(err);
            }
        };
        reader.onerror = (ev) => {
            var _a;
            reject((_a = ev.target) === null || _a === void 0 ? void 0 : _a.error);
        };
        reader.readAsText(f, "utf-8");
    });
}
/** The schema.json of the OpenVesselDefinition repo, from github.com or raw.githubusercontent.com,
 * at any ref (`master`, `refs/heads/master`, a commit) and with or without `?raw=true`. */
const OVD_SCHEMA_URL = /^https:\/\/(github\.com|raw\.githubusercontent\.com)\/tedivo\/OpenVesselDefinition\/.+\/schema\.json(\?.*)?$/;
const OVD_SCHEMA_IDS = ["IOpenVesselDefinitionV1", "OpenVesselDefinition"];
/**
 * Whether the parsed JSON declares itself as an OVD file (by `schema` or `$schema` plus
 * `$schemaId`) and has the root keys needed to open it. The structure is checked later by
 * `@tedivo/tedivo-ovd-validators`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isOvdSchema(json) {
    if (!json || typeof json !== "object")
        return false;
    const hasRootKeys = !!json.version && !!json.sizeSummary && !!json.shipData;
    if (json.schema) {
        return json.schema === "OpenVesselDefinition" && hasRootKeys;
    }
    else if (typeof json.$schema === "string") {
        return (OVD_SCHEMA_URL.test(json.$schema) && OVD_SCHEMA_IDS.includes(json.$schemaId) && hasRootKeys);
    }
    return false;
}
